module.exports = __webpack_public_path__ + "img/画板 1 拷贝 12.1a9b8707.jpg";